import { render } from "./staff_faxin_weituo.vue?vue&type=template&id=0b0243b4&scoped=true"
import script from "./staff_faxin_weituo.vue?vue&type=script&lang=js"
export * from "./staff_faxin_weituo.vue?vue&type=script&lang=js"

import "./staff_faxin_weituo.vue?vue&type=style&index=0&id=0b0243b4&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b0243b4"]])

export default __exports__